import React from 'react';
import { Typography, TypographyProps } from '@material-ui/core';
import { useStyles } from './CustomTypography.styles';
import { COLORS } from 'shared/constants/COLORS';
const { PRIMARY_TEXT, LIGHT_TEXT, ERROR_TEXT, PASS_TEXT, DARK_TEXT, WHITE, WARNING_TEXT } = COLORS;

type Props = {
  fontSize?: number;
  fontWeight?: 400 | 500 | 600 | 700;
  color?: 'mainGray' | 'primary' | 'danger' | 'success' | 'lightModeOnly' | 'white' | 'warning';
  text?: string | number;
  limitCharacters?: 'long' | 'short' | number | string;
  children?: React.ReactNode;
} & Omit<TypographyProps, 'color'>;
const CustomTypography: React.FC<Props> = ({
  fontSize = 16,
  fontWeight = 400,
  color,
  text,
  limitCharacters = 'unset',
  children,
  ...props
}) => {
  const styleProps = {
    fontSize: fontSize,
    fontWeight: fontWeight,
    color:
      color === 'mainGray'
        ? LIGHT_TEXT
        : color === 'primary'
          ? PRIMARY_TEXT
          : color === 'danger'
            ? ERROR_TEXT
            : color === 'success'
              ? PASS_TEXT
              : color === 'lightModeOnly'
                ? DARK_TEXT
                : color === 'white'
                  ? WHITE
                  : color === 'warning'
                    ? WARNING_TEXT
                    : undefined,
    maxLimitWidth: limitCharacters === 'long' ? 180 : limitCharacters === 'short' ? 120 : limitCharacters,
  };
  const classes = useStyles(styleProps)();

  return (
    <Typography className={`${classes.root} ${classes.limit__characters}`} {...props}>
      {text}
      {children}
    </Typography>
  );
};

export default CustomTypography;
